/**
 * @file scene.js
 * @desc This module contains Scene class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */


(/** @lends <global> */function (global) {
    'use strict';

    /**
     * Constructs Scene object.
     * @class
     * @constructor
     * @name Scene
     * @classdesc This is the base class for concrete game scenes.
     * @extends {PIXI.Container}
     * @requires PIXI
     * */
    var Scene = function() {
        PIXI.Container.call(this);
        this._paused  =  false;
    };

    Scene.prototype = Object.create(PIXI.Container.prototype);

    Scene.prototype.constructor = Scene;

    /**
     * Updates scene components.
     * @param {Number} dt Time shift since last update call
     * @param {Number} [time] Absolute time since game starts
     * @abstract
     * @memberOf Scene
     * */
    Scene.prototype.update = function(dt, time) {

    };

    /**
     * Pauses scene. Should be called from derived scene class.
     * @memberOf Scene
     * */
    Scene.prototype.pause = function() {
        this._paused = true;
    };

    /**
     * Resumes scene. Should be called from derived scene class.
     * @memberOf Scene
     * */
    Scene.prototype.resume = function() {
        this._paused = false;
    };
    
    
    Scene.prototype.destroy = function(textures, baseTextures) {
        for (var i = this.children.length - 1; i >= 0; i--) {
            var child = this.children[i];
            if (child.destroy) {
                child.destroy(textures, baseTextures);
            }
            this.removeChild(child);
        }
    };
    
    /**
     * Make all user activities inaccessible except exit to lobby
     * @memberOf Scene
     * */
    Scene.prototype.onNetworkError = function() {

    };
    
    
    Object.defineProperties(Scene.prototype, {
        /**
         * Check if scene paused or not.
         * @returns {Boolean} Scene paused or not
         * @memberOf Scene
         * */
        paused: {
            get: function() {
                return this._paused;
            }
        }
    });

    global.Scene = Scene;
}(typeof module === 'object' && module.exports || this));


//////////////////
// WEBPACK FOOTER
// ./src/library/scene.js
// module id = 9
// module chunks = 0